import {isExpired, decodeToken} from "react-jwt";
import {useNavigate} from "react-router-dom";

const RouterProtector = () => {
    console.log('RouterProtector');
    const token = sessionStorage.getItem('token');
    // const decodedToken = decodeToken(token);
    const isTokenExpired = isExpired(token);
    return !(!token || isTokenExpired);
}

export default RouterProtector;
